import { Row } from "@amzn/stencil-react-components/layout";
import { Link, LinkIconPosition } from "@amzn/stencil-react-components/link";
import IconExternalLinkSmall from "@amzn/stencil-react-icons/icons/icon-external-link-small";
import React, { FC, MouseEvent, useState } from "react";
import { HardwareSupportFlyout } from "../../../../common/components/HardwareSupportFlyout/hardware-support-flyout";
import { OrderMessagesIcon } from "../../../../common/components/OrderMessagesIcon/order-messages-icon";
import { getString } from "../../../../common/uistringlabels/ui-string-utils";
import type { Order } from "../../../../services/orders/orders.types";
import { UserPermissions } from "../../../../services/user-permissions/user-permissions";

interface OrderSupportActionsProps {
  order: Order;
  onMessageSent: () => void;
}

export const OrderSupportActions: FC<OrderSupportActionsProps> = ({ order, onMessageSent }) => {
  const [isFlyoutOpen, setIsFlyoutOpen] = useState(false);

  const openFlyout = (event: MouseEvent) => {
    event.preventDefault();
    setIsFlyoutOpen(true);
  };

  return (
    <>
      <Row alignItems="center" gridGap="S200" data-testid="order-support-actions">
        <Link
          href="#"
          onClick={openFlyout}
          icon={<IconExternalLinkSmall aria-hidden />}
          iconPosition={LinkIconPosition.Trailing}
        >
          {getString("orderTracking.amznham.support.link")}
        </Link>
        <OrderMessagesIcon
          hasOrderSupport={order.orderSupport?.supportRequested ?? false}
          lastCommentOn={order.orderSupport?.lastCommentInfo?.on}
          lastCommentBy={order.orderSupport?.lastCommentInfo?.by}
          orderId={order.orderId}
          currentUser={UserPermissions.current.username ?? ""}
          title={order.items?.[0]?.itemInformation?.name ?? ""}
          orderReference={order.orderReference ?? ""}
          orderTaxId={order.orderId}
        />
      </Row>
      {isFlyoutOpen && (
        <HardwareSupportFlyout
          onClose={() => setIsFlyoutOpen(false)}
          order={order}
          onMessageSent={onMessageSent}
        />
      )}
    </>
  );
};
